import React from "react";
import { Helmet } from "react-helmet-async";

const Dhanbad = () => {
  return (
    <>
      <Helmet>
        <title>Fly Ash Bricks, Blocks & Paver Blocks in Dhanbad | Anil Flyash Bricks</title>
        <meta
          name="description"
          content="Anil Flyash Bricks is the leading manufacturer and supplier of fly ash bricks, blocks, and paver blocks in Dhanbad. Buy eco-friendly, durable, and affordable building materials for all construction needs."
        />
        <meta
          name="keywords"
          content="fly ash bricks in Dhanbad, paver blocks in Dhanbad, fly ash blocks Dhanbad, brick dealers in Dhanbad, flyash bricks manufacturer Dhanbad, paver block supplier Dhanbad, Anil Flyash Bricks Dhanbad, bricks near me Dhanbad"
        />
        <link rel="canonical" href="https://anilbricks.com/flyash-bricks-in-dhanbad" />
      </Helmet>

      <div className="py-16 px-6 md:px-20 bg-gray-50 text-gray-800">
        <h1 className="text-3xl font-bold mb-6 text-green-700 text-center">
          Fly Ash Bricks, Blocks & Paver Blocks in Dhanbad
        </h1>

        <p className="text-lg leading-relaxed mb-4">
          <strong>Anil Flyash Bricks</strong> is one of the most trusted names in{" "}
          <strong>Dhanbad</strong> when it comes to high-quality{" "}
          <strong>fly ash bricks, fly ash blocks, and paver blocks</strong>. We are dedicated
          to providing durable, eco-friendly, and cost-effective construction materials that
          meet the modern standards of strength and sustainability.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          As a leading <em>brick manufacturer in Dhanbad</em>, we supply a wide range of
          fly ash products suitable for residential, commercial, and industrial projects.
          Our bricks are machine-made using high-grade fly ash, cement, and stone dust,
          ensuring consistent strength, accurate shape, and long-lasting performance.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Our <strong>fly ash blocks</strong> are a popular choice among builders for their
          lightweight yet strong composition. They help reduce construction costs and improve
          insulation, making them ideal for high-rise buildings and modern homes. In addition,
          our <strong>paver blocks</strong> are widely used for pavements, parking lots,
          driveways, and gardens — offering both beauty and strength.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          We proudly serve the entire Dhanbad region including{" "}
          <strong>Govindpur, Katras, Nirsa, Baliapur, and Sindri</strong>. With a strong
          logistics network, we ensure timely delivery and complete customer satisfaction.
          Whether you need a few thousand bricks or bulk supply for large projects,
          Anil Flyash Bricks is your reliable construction partner.
        </p>

        <p className="text-lg leading-relaxed mb-6">
          Our focus on quality, eco-friendliness, and precision manufacturing has made us a
          top choice for <em>builders, contractors, and engineers in Dhanbad</em>. Join the
          growing list of happy clients who trust our products for long-term durability and
          cost efficiency.
        </p>

        <div className="text-center">
          <a
            href="/#contact"
            className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-full font-semibold shadow-md transition"
          >
            Get a Free Quote
          </a>
        </div>
      </div>
    </>
  );
};

export default Dhanbad;
